const images = {
  men: {
    tshirt: [
      require("./men/tshirts/1.png"),
      require("./men/tshirts/2.png"),
      require("./men/tshirts/3.png"),
      require("./men/tshirts/4.png"),
      require("./men/tshirts/5.png"),
      require("./men/tshirts/6.png"),
      require("./men/tshirts/7.png"),
      require("./men/tshirts/8.png"),
      require("./men/tshirts/9.png"),
      require("./men/tshirts/10.png"),
      require("./men/tshirts/11.png"),
      require("./men/tshirts/12.png"),
    ],
    shirt: [
      require("./men/shirts/0.png"),
      require("./men/shirts/1.png"),
      require("./men/shirts/2.png"),
      require("./men/shirts/3.png"),
      require("./men/shirts/4.png"),
      require("./men/shirts/5.png"),
      require("./men/shirts/6.png"),
      require("./men/shirts/7.png"),
      require("./men/shirts/8.png"),
    ],
    sweater: [
      require("./men/sweaters/0.png"),
      require("./men/sweaters/1.png"),
      require("./men/sweaters/2.png"),
      require("./men/sweaters/3.png"),
      require("./men/sweaters/4.png"),
      require("./men/sweaters/5.png"),
      require("./men/sweaters/6.png"),
      require("./men/sweaters/7.png"),
      require("./men/sweaters/8.png"),
      require("./men/sweaters/9.png"),
      require("./men/sweaters/10.png"),
    ],
    jacket: [
      require("./men/jackets/0.png"),
      require("./men/jackets/1.png"),
      require("./men/jackets/2.png"),
      require("./men/jackets/3.png"),
      require("./men/jackets/4.png"),
      require("./men/jackets/5.png"),
      require("./men/jackets/6.png"),
      require("./men/jackets/7.png"),
      require("./men/jackets/8.png"),
      require("./men/jackets/9.png"),
      require("./men/jackets/10.png"),
      require("./men/jackets/11.png"),
    ],
  },
  women: {
    tshirt: [
      require("./women/tshirts/0.png"),
      require("./women/tshirts/1.png"),
      require("./women/tshirts/2.png"),
      require("./women/tshirts/3.png"),
      require("./women/tshirts/4.png"),
      require("./women/tshirts/5.png"),
      require("./women/tshirts/6.png"),
      require("./women/tshirts/7.png"),
      require("./women/tshirts/8.png"),
      require("./women/tshirts/9.png"),
    ],
    dress: [
      require("./women/dresses/0.png"),
      require("./women/dresses/1.png"),
      require("./women/dresses/2.png"),
      require("./women/dresses/3.png"),
      require("./women/dresses/4.png"),
      require("./women/dresses/5.png"),
    ],
    sweater: [
      require("./women/sweaters/0.png"),
      require("./women/sweaters/1.png"),
      require("./women/sweaters/2.png"),
      require("./women/sweaters/3.png"),
      require("./women/sweaters/4.png"),
      require("./women/sweaters/5.png"),
      require("./women/sweaters/6.png"),
      require("./women/sweaters/7.png"),
      require("./women/sweaters/8.png"),
    ],
    jacket: [
      require("./women/jackets/0.png"),
      require("./women/jackets/1.png"),
      require("./women/jackets/2.png"),
      require("./women/jackets/3.png"),
      require("./women/jackets/4.png"),
      require("./women/jackets/5.png"),
      require("./women/jackets/6.png"),
      require("./women/jackets/7.png"),
      require("./women/jackets/8.png"),
      require("./women/jackets/9.png"),
      require("./women/jackets/10.png"),
    ],
  },
};

export default images;
